import moment from "moment";
import { shortDateFormatter } from "shared/date-formatter";
import { formatPriceInput } from "shared/price-input-formatter";
import { YesNoType } from "type/boolean-choice-type";

/**
 * How Lead Details renders the Lead Readiness fields. Anything else that shows one of these
 * values beside it — the Search Agent's profile suggestions — formats through here, so the same
 * value can never read two different ways on one page.
 */

export const formatLeadTimeline = (
	transactionTimelineStart: string | undefined,
	transactionTimelineEnd: string | undefined,
	justBrowsing: boolean | undefined
) => {
	if (justBrowsing) {
		return "Just Browsing";
	}
	return `${shortDateFormatter(moment(transactionTimelineStart))} - ${shortDateFormatter(moment(transactionTimelineEnd))}`;
};

/** Lead Details only shows a timeline once it has an end date, or is just browsing. */
export const hasLeadTimeline = (transactionTimelineEnd: string | undefined, justBrowsing: boolean | undefined) => {
	return !!transactionTimelineEnd || !!justBrowsing;
};

export const formatLeadPrice = (transactionPrice: number) => {
	return formatPriceInput(transactionPrice);
};

export const formatLeadPreApproval = (mortgagePreApproval: boolean) => {
	return YesNoType.getByValue(mortgagePreApproval)?.label;
};
